// extracted by mini-css-extract-plugin
export default {"user-info":"UserInfoPanel_user-info__xyIzP","user-name":"UserInfoPanel_user-name__dZLU6"};